/**
 * GB API
 * API for GB Component
 *
 * The version of the OpenAPI document: -
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { GrundstueckId } from './grundstueckId';


export interface LoadGbGeschaeftSichtByGrundstueckIdsRequest { 
    grundstueckIds?: Array<GrundstueckId>;
    auftragLoadOption?: LoadGbGeschaeftSichtByGrundstueckIdsRequest.AuftragLoadOptionEnum;
    offset?: number;
    limit?: number;
    sortDirection?: LoadGbGeschaeftSichtByGrundstueckIdsRequest.SortDirectionEnum;
    sort?: LoadGbGeschaeftSichtByGrundstueckIdsRequest.SortEnum;
}
export namespace LoadGbGeschaeftSichtByGrundstueckIdsRequest {
    export type AuftragLoadOptionEnum = 'ALLE' | 'HAENGIGE';
    export const AuftragLoadOptionEnum = {
        ALLE: 'ALLE' as AuftragLoadOptionEnum,
        HAENGIGE: 'HAENGIGE' as AuftragLoadOptionEnum
    };
    export type SortDirectionEnum = 'ASC' | 'DESC';
    export const SortDirectionEnum = {
        ASC: 'ASC' as SortDirectionEnum,
        DESC: 'DESC' as SortDirectionEnum
    };
    export type SortEnum = 'TAGEBUCHNUMMER' | 'STATUS' | 'EINGANG_TAGEBUCH';
    export const SortEnum = {
        TAGEBUCHNUMMER: 'TAGEBUCHNUMMER' as SortEnum,
        STATUS: 'STATUS' as SortEnum,
        EINGANGTAGEBUCH: 'EINGANG_TAGEBUCH' as SortEnum
    };
}


